import { lazyOpenChecker } from 'owa-editor-acc-checker';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import onOpenAccessibilityChecker from 'owa-calendar-compose-form-actions/lib/actions/onOpenAccessibilityChecker';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import { orchestrator } from 'satcheljs';
import { updateSidePaneType } from 'owa-calendar-compose-form-actions';

/**
 * Orchestrator which opens the Accessibility checker in the side pane
 */
export default orchestrator(onOpenAccessibilityChecker, () => {
    const viewState = getFullComposeViewState();

    if (!viewState.accChecker.isOpen) {
        lazyOpenChecker.import().then(openChecker => {
            openChecker(viewState.accChecker, viewState.bodyViewState);
            updateSidePaneType(SidePaneType.AccessibilityChecker);
        });
    }
});
